<template>
	<div id="currencyModal" style="display: block" class="modal" role="dialog">
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog">
			<div class="modal-content">
				<loading
					:active.sync="isLoading"
					class="loading"
					:is-full-page="false"
				></loading>
				<div class="modal-header">
					<h4 class="titleModal">Select Currency</h4>
					<button class="closeButton" @click="$emit('close')">
						<img
							src="../../resources/images/icons/close-icon-white.svg"
							alt=""
							class="closeIcon"
						/>
					</button>
				</div>
				<div class="modal-body">
					<div class="searchboxWrapper">
						<div class="searchbox">
							<img src="../../resources/images/icons/search-icon.svg" alt="" />
							<input
								type="text"
								class="searchInput"
								placeholder="Search Currencies"
								@input="inputKeyword($event)"
							/>
						</div>
					</div>
					<div class="currenciesList">
						<div
							v-for="(currency, currencyKey) in filterCurrenciesList"
							:key="currencyKey"
							class="cellContainer currencyCell"
							:class="{ selected: currency.code === newCurrency }"
							@click="
								choseAnotherCurrency(currency.code, currency.symbol_native)
							"
						>
							<div class="currencyWrapper">
								<div class="title">{{ currency.name }}</div>
								<div class="detail">
									<div class="symbol">{{ currency.code }}</div>
								</div>
							</div>
						</div>
						<div
							v-if="Object.entries(this.filterCurrenciesList).length === 0"
							class="noMatchPlaceholder"
						>
							<span>No matching results</span>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button class="cancelButton" @click="$emit('close')">
						Cancel
					</button>
					<button
						class="doneButton"
						:class="{ active: newCurrency !== currencyCode }"
						type="submit"
						@click="currencySelectDone"
					>
						Done
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import CurrenciesList from "../../data/currency.json";
export default {
	name: "Currency",
	props: ["currencyCode", "currencySymbol"],
	data() {
		return {
			CurrenciesList,
			filterCurrenciesList: CurrenciesList,
			newCurrency: this.currencyCode,
			newSymbol: this.currencySymbol,
			filterKeyword: "",
			isLoading: false
		};
	},
	components: {
		Loading
	},
	mounted() {
		const searchInput = document.querySelector("#currencyModal .searchInput");
		searchInput.focus();
	},
	methods: {
		choseAnotherCurrency(currencyCode, symbol) {
			this.newCurrency = currencyCode;
			this.newSymbol = symbol;
		},
		inputKeyword(event) {
			const keyword = event.target.value;
			this.filterKeyword = keyword;
			this.getFilterCurrencies();
		},
		getFilterCurrencies() {
			this.filterCurrenciesList = Object.fromEntries(
				Object.entries(CurrenciesList).filter(
					([code, details]) =>
						details.name
							.toLowerCase()
							.includes(this.filterKeyword.trim().toLowerCase()) ||
						details.code
							.toLowerCase()
							.includes(this.filterKeyword.trim().toLowerCase())
				)
			);
		},
		async currencySelectDone() {
			try {
				this.isLoading = true;
				await this.$emit("currencyIsChanged", this.newCurrency, this.newSymbol);
			} catch (error) {
				return error;
			}
		}
	}
};
</script>
